module.exports = __webpack_public_path__ + "static/media/first.7a6c60d3.svg";